import {createSmartAction, createReducer} from 'redux-smart-actions';
import {toast} from 'react-toastify';
import {Notification, options} from 'ui/toastify/notification';
import {prop} from 'ramda';
import {createSelector} from 'reselect';

export const setLastNotification = createSmartAction(lastNofication => ({lastNofication}));
export const toggleNotificationsEnabled = createSmartAction();
export const setNotificationsEnabled = createSmartAction(notificationsEnabled => ({
  notificationsEnabled,
}));

export const getNotification = createSmartAction(() => ({
  request: {
    url: '/wp/v2/notifications?per_page=1',
  },
  meta: {
    onSuccess: (response, requestAction, {dispatch, getState}) => {
      const lastNofication = getState()?.notifications?.lastNofication;
      const latestRemoteNotification = response.data[0];
      if (latestRemoteNotification?.id !== lastNofication?.id) {
        dispatch(setLastNotification(latestRemoteNotification));
        toast(<Notification latestNotification={latestRemoteNotification.acf} />, options);
      }
      return response;
    },
  },
}));

export const reducer = createReducer(
  {
    [setLastNotification.toString()]: (s, {lastNofication}) => ({...s, lastNofication}),
    [toggleNotificationsEnabled.toString()]: s => ({
      ...s,
      notificationsEnabled: !s.notificationsEnabled,
    }),
    [setNotificationsEnabled.toString()]: (s, {notificationsEnabled}) => ({
      ...s,
      notificationsEnabled,
    }),
  },
  {
    lastNofication: null,
    notificationsEnabled: false,
  },
);

const getNotificationsSelector = prop('notifications');
export const getLastNotificationSelector = createSelector(
  getNotificationsSelector,
  prop('lastNofication'),
);
export const getNotificationsEnabledSelector = createSelector(
  getNotificationsSelector,
  prop('notificationsEnabled'),
);
